import { configureStore } from "@reduxjs/toolkit";
import Logger from "redux-logger";
import core from "./coreReducer";
import users from "./users/reducer";
import settings from "./settings/reducer";
import verificationRequests from "./ninVerification/reducer";
import onboardingPersonsApplications from "./onboardingPersons/reducer"
import onboardingPersonsWorkflows from "./onboardingPersons/workflowsReducer"
import idvCompaniesWorkflows from "./idvCompanies/workflowsReducer"
import crmCompanies from "./crmCompanies/reducer"
import crmCompany from "./crmCompanies/workflowsReducer"
import crmPersons from "./crmPersons/reducer"
import crmPerson from "./crmPersons/workflowsReducer"
import kycVerification from "./verification/reducer"
import downloads from "./downloads/reducer";
import auditTrail from "./auditTrailReducer";

const myWindow = window as any;
const toolsName = "__REDUX_DEVTOOLS_EXTENSION__";
const devTools: any = myWindow[toolsName]
  ? myWindow[toolsName]()
  : (f: any) => f;
// const reducers = combineReducers({
//   core,
//   users,
//   settings,
//   verificationRequests,
// });
//const middleware = applyMiddleware(createLogger(), ReduxThunk);
//const store: any = middleware(devTools(createStore))(reducers);


export const store = configureStore({
  reducer: {
    core,
    users,
    settings,
    verificationRequests,
    kycVerification,
    onboardingPersonsApplications,
    onboardingPersonsWorkflows,
    idvCompaniesWorkflows,
    crmCompanies,
    crmCompany,
    crmPersons,
    crmPerson,
    downloads,
    auditTrail
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false,
  })
  .concat(Logger),
  //devTools: process.env.NODE_ENV !== 'production', // #Refactor: Use this to disable devtools in production. Pay attention to the env setup
});